// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Xg","icon":"i_Xh","label":"i_Xi","text":"i_Xj"};